<template>
  <v-form v-model="isValid">
    <v-row no-gutters>
      <v-col cols="12">
        <v-text-field dense class="col" v-model="formData.name" label="Name"
                      :rules="[rules.nonEmpty(formData.name, 'Name')]" required/>
      </v-col>
      <v-col cols="12">
        <v-text-field dense class="col" v-model="formData.settings.completeName" label="Company name"
                      :rules="[rules.nonEmpty(formData.settings.completeName, 'Complete name')]" required/>
      </v-col>
      <v-col cols="12">
        <v-text-field dense class="col" v-model="formData.settings.shortName" label="Company name short"
                      :rules="[rules.nonEmpty(formData.settings.shortName, 'Short name')]" required/>
      </v-col>
      <v-col cols="12">
        <v-text-field dense class="col" v-model="formData.settings.logo" label="Heading logo"/>
      </v-col>
      <v-col cols="12">
        <v-text-field dense class="col" v-model="formData.settings.shortLogo" label="Avatar logo"/>
      </v-col>
      <v-col cols="12">
        <v-checkbox dense class="col" v-model="formData.settings.branding" :label="`Branding: ${formData.settings.branding ? 'Yes': 'No'}`" />
      </v-col>
      <v-col cols="12">
<!--        <v-row no-gutters>-->
<!--          <v-col cols="10">-->
<!--            <v-text-field-->
<!--              dense class="col"-->
<!--              v-model="companyLinkedinUrls[0]"-->
<!--              :rules="[rules.linkedinCompanyUrl(companyLinkedinUrls[0])]"-->
<!--              label="Linkedin company url"/>-->
<!--          </v-col>-->
<!--          <v-col cols="2">-->
<!--            <v-btn small icon @click="addCompanyUrl"><v-icon color="success">mdi-plus</v-icon></v-btn>-->
<!--            <v-btn small icon @click="removeCompanyUrl(0)"><v-icon color="error">mdi-minus</v-icon></v-btn>-->
<!--          </v-col>-->
<!--        </v-row>-->
        <v-row no-gutters v-for="(url, key) in companyLinkedinUrls" :key="key">
          <v-col cols="10">
            <v-text-field
              dense class="col"
              :rules="[rules.linkedinCompanyUrl(companyLinkedinUrls[key])]"
              v-model="companyLinkedinUrls[key]"
              label="Linkedin company url"/>
          </v-col>
          <v-col cols="2">
            <v-btn small icon @click="addCompanyUrl"><v-icon color="success">mdi-plus</v-icon></v-btn>
            <v-btn small icon @click="removeCompanyUrl(key)" v-if="key > 0"><v-icon color="error">mdi-minus</v-icon></v-btn>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-right">
        <v-btn class="default" @click="cancel()">Cancel</v-btn>
        <v-btn class="ml-3 success" @click="save()" :disabled="!isValid">Save</v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  import {nonEmptyField, validPassword, validEmail, linkedinCompanyUrl} from "../../helpers/helpers";

  export default {
    name: "settingsUserForm",
    props:['userData', 'linkedinUrls'],
    data: () => {
      return {
        formData: {
          name: '',
          email: '',
          role: '',
          settings: {
            completeName: '',
            shortName: '',
            shortLogo: '',
            logo: '',
            branding: true
          }
        },
        companyLinkedinUrls: [],
        rules: {
          nonEmpty: nonEmptyField,
          validEmail: validEmail,
          validPassword: validPassword,
          linkedinCompanyUrl: linkedinCompanyUrl,
        },
        isValid: false,
        submitting: false,
      }
    },
    mounted() {
      this.formData = JSON.parse(JSON.stringify(this.userData));
      this.companyLinkedinUrls = this.linkedinUrls.length > 0 ? JSON.parse(JSON.stringify(this.linkedinUrls)) : [''];
    },
    computed: {},
    methods: {
      cancel(data) {
        this.$emit('cancel', data);
      },
      addCompanyUrl(){
        this.companyLinkedinUrls.push('');
      },
      removeCompanyUrl(key){
        this.companyLinkedinUrls = this.companyLinkedinUrls.filter((e,i) => i !== key);
      },
      save() {
        if (this.isValid) {
          const payload = {
            clientId: this.userData.clientId,
            userId: this.userData._id,
            name: this.formData.name,
            settings: this.formData.settings,
            linkedinUrls: this.companyLinkedinUrls
          }
          this.submitting = true;
          this.$store.dispatch('updateSettings', payload)
            .then(success => {
              this.submitting = false;
              if (success) {
                this.cancel({reload:true});
              }
            })
        }
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Forms/settingsUserForm.vue